import classNames from "classnames";

import SvgIcon from "../SvgIcon";

import styles from "./index.module.scss";

interface ITile {
  link_url: string;
  description_text: string | (() => string);
  background_image: string | (() => string);
  title: string | (() => string);
  background_color: string;
  target?: "_blank" | "_self";
}

interface ICustomTilesProps {
  tiles: ITile[];
}

function CustomTiles({ tiles }: ICustomTilesProps) {
  const getTileValue = (value: string | (() => string)): string => {
    return typeof value === "function" ? value() : value;
  };

  return (
    <div className={styles.tiles}>
      {tiles.map((tile, index) => {
        const title = getTileValue(tile.title);
        const description = getTileValue(tile.description_text);
        const backgroundImage = getTileValue(tile.background_image);

        return (
          <a
            key={tile.link_url || index}
            href={tile.link_url}
            target={tile.target || "_self"}
            rel={tile.target === "_blank" ? "noreferrer" : undefined}
            className={classNames(styles.tile, {
              [styles.tile_disabled]: !tile.link_url,
            })}
            style={{
              background: `url(${backgroundImage}) center/cover`,
              textDecoration: "none",
            }}>
            <div className={styles.tile_bottom}>
              <div className={styles.tile_text}>
                <p className={styles.tile_title}>{title}</p>
                <p className={styles.tile_description}>{description}</p>
              </div>

              <div className={styles.tile_playContainer}>
                <SvgIcon type="FiPlayCircle" />
              </div>
            </div>

            <div
              className={classNames(
                styles.tile_bg,
                styles[`tile_bg_${tile.background_color}`],
              )}
              style={{
                backgroundColor: tile.background_color,
                opacity: 0.65,
              }}
            />
          </a>
        );
      })}
    </div>
  );
}

CustomTiles.defaultProps = {
  tiles: [],
};

export default CustomTiles;
